<template>
    <div class="cms-menu container">
        <div class="row py-5">
            <div class="col-12"><h1 class="pstitle">Admin CMS - Menu</h1></div>
        </div>

        <div class="row">
            <div v-for="card in cards"
                 :key="card.link"
                 class="col-12 col-md-6 col-lg-4 mb-4 cms-card-col">
                <div class="boat-card bboat-bg pb-4 w-100 cms-card">
                    <div>
                        <div class="boat-model pt-4 px-4">{{ card.title }}</div>
                        <div class="boat-price px-4">{{ card.description }}</div>
                    </div>
                    <div class="px-4 pt-4">
                        <custom-button class="btn-main"
                                       v-on:btnClicked="goTo(card.link)">
                            {{ card.buttonLabel }}
                        </custom-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomButton from "../components/atoms/CustomButton.vue";

export default {
    name: "CmsMenuPage",
    components: {
        CustomButton,
    },
    data() {
        return {
            cards: [
                {
                    title: "Trader Creation",
                    description: "Create a new trader instance for a brand.",
                    buttonLabel: "Open",
                    link: "cms/trader",
                },
                {
                    title: "Brand Settings",
                    description: "Manage settings for each brand.",
                    buttonLabel: "Open",
                    link: "cms/brands",
                },
                {
                    title: "Site Options",
                    description: "Edit site-wide options.",
                    buttonLabel: "Open",
                    link: "cms/site-options",
                },
            ],
        };
    },
    methods: {
        goTo(link) {
            window.location = link;
        },
    },
};
</script>

<style lang="scss">
.cms-menu {
    .cms-card-col {
        display: flex;
    }

    // Equal-height cards, with the button pinned to the bottom
    .cms-card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
}
</style>